import { fromJS } from 'immutable'

import strings from './strings.json'

const iStrings = fromJS(strings)

export { iStrings }
export default strings
